// node modules
import mixpanel from 'mixpanel-browser';
// config
import { ENV, LOCAL } from 'config';
import getDeviceDetails from 'utils/helpers/deviceDetails';
import AppService from 'modules/App';
import { MIXPANEL_KEY, MIXPANEL_UAT_LIVE_KEY } from './consts';
import { ExtractEventOptions, IMixpanelEvents, IUserData } from './types';

// Moved from ui-pro-web-4/src/modules/Analytics/service

class BaseAnalyticsService<T extends IMixpanelEvents> {
  private readonly token: string;
  private readonly config: Record<string, string>;
  private readonly serviceEnabled: boolean;
  userData: IUserData | undefined;

  constructor(
    config: {
      token?: string;
      serviceEnabled?: boolean;
    } = {},
  ) {
    this.token =
      config.token || ENV === 'PROD' ? MIXPANEL_KEY : MIXPANEL_UAT_LIVE_KEY;
    this.config = {};

    this.serviceEnabled =
      config.serviceEnabled === undefined
        ? ['UAT', 'QA', 'PROD'].includes(ENV) && !LOCAL
        : config.serviceEnabled;
  }

  setUserData(userData: IUserData) {
    this.userData = userData;
  }

  init() {
    if (!this.serviceEnabled) return;

    mixpanel.init(this.token, this.config);
    mixpanel.set_config({ ignore_dnt: true });
  }

  setUser(profileId: string) {
    if (!this.serviceEnabled) return;

    mixpanel.people.set({ 'user id': profileId });
    mixpanel.identify(profileId);
  }

  logout() {
    if (!this.serviceEnabled) return;

    mixpanel.reset();
  }

  sendEvent<E extends T['event']>(
    event: E,
    options?: ExtractEventOptions<T, E>,
    addDeviceDetails = false,
  ) {
    if (!this.serviceEnabled) return;

    mixpanel.track(event, {
      'Phone number': this.userData?.mobile,
      UCC: this.userData?.ucc,
      'Profile ID': this.userData?.profileId,
      'Web Platform': 'TV',
      web_theme: AppService.getTheme(),
      $CleverTap_user_id: this.userData?.profileId,
      ...options,
      ...(addDeviceDetails ? getDeviceDetails() : {}),
    });
    mixpanel.register_once({ Platform: 'Web' });
  }
}

export default BaseAnalyticsService;
